export default __webpack_public_path__ + "static/media/4.eee2f911.png";